import { render, staticRenderFns } from "./TextHidden.vue?vue&type=template&id=86db406a&scoped=true&"
import script from "./TextHidden.vue?vue&type=script&lang=js&"
export * from "./TextHidden.vue?vue&type=script&lang=js&"
import style0 from "./TextHidden.vue?vue&type=style&index=0&id=86db406a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86db406a",
  null
  
)

export default component.exports